/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Info } from '../../core/models/common/Info';
import { License } from '../../core/models/common/License';
import { DeleteNodeCommand } from './DeleteNodeCommand';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete the license.
 * 
 * @author eric.wittmann@gmail.com
 * @extends DeleteNodeCommand
 * @class
 */
export class DeleteLicenseCommand extends DeleteNodeCommand<License> {
    public constructor(info? : any) {
        if(((info != null && info instanceof <any>Info) || info === null)) {
            let __args = arguments;
            super(Constants.PROP_LICENSE, info);
        } else if(info === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {License}
     */
    readNode(doc : Document, node : any) : License {
        let license : License = doc.info.createLicense();
        Library.readNode(node, license);
        return license;
    }
}
DeleteLicenseCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteLicenseCommand";
DeleteLicenseCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




